<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../../assets/images/banner_intro.jpg" />
            <div class="btext">
                <h3>股权/资金投资流程</h3>
                <p>以客户为本，真诚服务，持续创新，追求卓越</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/' }">业务流程</el-breadcrumb-item>
                <el-breadcrumb-item>股权/资金投资流程</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                        default-active="3"
                        class="el-menu-vertical-demo">
                        <router-link :to="{ path: '/borrowProcess' }">
                            <el-menu-item index="1"><span slot="title" >借贷服务</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/debtTransferProcess' }">
                            <el-menu-item index="2"><span slot="title">债权转让服务</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/ecInvestmentProcess' }">
                            <el-menu-item index="3"><span slot="title">股权/资金投资服务</span></el-menu-item>
                        </router-link>
                        <!-- <router-link :to="{ path: '/dataDownload' }">
                            <el-menu-item index="4"><span slot="title">资料下载</span></el-menu-item>
                        </router-link> -->
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <div v-html="this.content">

                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import  {reqEcInvestmentProcessList} from "../../../api/contentManagement-api"
    export default {
        data(){
            return{
                content:'',
            }
        },
        methods:{
            getEcInvestmentProcess(){
                reqEcInvestmentProcessList().then((res)=>{
                    if(res.data.code===1){
                        this.content=res.data.data[0].content;
                    }else{
                        this.content='<p>抱歉，暂无数据</p>'
                    }
                })
            }

        },
        mounted(){
            this.getEcInvestmentProcess();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contentManagement/businessSituation/ecInvestmentProcess.vue